/**
 * Created by razial on 21.05.2026.
 */

if (cleverapps.styles.PackOfferComponent) {
    cleverapps.styles.PackOfferComponent[Offers.TYPES.KINGSCUP] = {
        showFromBottom: {
            x: 0,
            y: -200
        },
        pack: {
            offsetX: 300,
            offsetY: 205,
            title: {
                x: { align: "center", dx: 220 },
                y: { align: "center", dy: -90 },
                width: 200,
                font: cleverapps.styles.FONTS.DARK_PACK_BUTTON_TEXT
            },
            visibleResolutionModes: [
                cleverapps.WideMode.SQUARE,
                cleverapps.WideMode.HORIZONTAL
            ],
            spaceRequired: 0
        },
        tap: {
            x: { align: "left", dx: -380 },
            y: { align: "center", dy: 410 },
            rotation: 0,
            zIndex: 3,
            animation: {
                x: { align: "left", dx: 0 },
                y: { align: "top", dy: 0 }
            }
        }
    };
}
